import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import {getToken} from '@/utils/auth'
import {$my} from "@/my/my"
import router from "@/router"
const isHttps = window.location.protocol === 'https:';
let hostApi = process.env.VUE_APP_BASE_API
if(isHttps){
  hostApi = 'https://'+process.env.VUE_APP_BASE_API
}else{
  hostApi = 'http://'+process.env.VUE_APP_BASE_API
}
// create an axios instance
const service = axios.create({
  baseURL: hostApi + '/' + $my.pushApi + '/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers[$my.tokenKey] = getToken()
    }
    if (typeof config.data === 'object') {
      if (config.data.hasOwnProperty('page') && config.data.hasOwnProperty('size')) {
        config.data = $my.obj_filter(config.data)
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    return response.data
  },
  error => {
    console.log(error) // for debug
    let msg = '发生错误'
    if (error.hasOwnProperty('response') && error.response && error.response.hasOwnProperty('status')) {
      let res = error.response
      switch (res.status) {
        case 401:
          msg = res.hasOwnProperty('data') && res.data.hasOwnProperty('message') ? res.data.message : '未登录或者登录已过期'
          // 重新登录
          Message({
            message: msg,
            type: 'error',
            duration: 5 * 1000
          })
          store.dispatch('user/logout')
          router.replace({
            path: '/login',
            query: {redirect: router.currentRoute.fullPath}
          })
          break
        default:
          msg = res.hasOwnProperty('data') && res.data.hasOwnProperty('message') ? res.data.message : '发生错误'
          Message({
            message: msg,
            type: 'error',
            duration: 5 * 1000
          })
          break
      }
    } else {
      Message({
        message: msg,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
